import {FormTemplateRuleParameterType} from './formTemplateRuleParameterType' // eslint-disable-line 
/**
 * A parameter is an input to a template rule.
 *
 * @export
 * @class FormFieldTemplateRuleParameter
 */
export class FormTemplateRuleParameter {
  /**
   * Creates an instance of FormTemplateRuleParameter.
   * @param {String} name The name of the parameter.
   * @param {FormTemplateRuleParameterType} type The type of the parameter.
   * @param {any} source A tokenizer provides values.
   * @param {any} defaultValue The default value for the parameter.
   * @memberof FormTemplateRuleParameter
   */
  constructor ({ identifier, type, source, defaultValue } = {}) {
    this.identifier = identifier
    this.type = type
    this.source = source
    this.value = defaultValue
  }
}
